import state from './moduloVerificarQrState.js';
import mutations from './moduloVerificarQrMutations.js';
import actions from './moduloVerificarQrActions.js';
import getters from './moduloVerificarQrGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
